export default "__VITE_ASSET__nIUc4nRG__"